// Core
import { createActions } from 'redux-actions';

export const uiActions = createActions({
    SET_SELECTED_CURRENCY:    (currency) => currency,
    SET_AVAILABLE_CURRENCIES: (currencies) => currencies,
    SET_MODAL_STATUS:         (modal, status) => ({ modal, status }),
});
